class ActionFactory {
    switchObject;
    specialHandlers;

    constructor() {
        this.switchObject = {};
        this.specialHandlers = new Map();
    }

    create(props) {
        const key = `${props.type}:${props.guiText}`;
        if (this.specialHandlers.has(key)) {
            return this.specialHandlers.get(key)(props);
        }
        if (this.switchObject.hasOwnProperty(props.type)) {
            return this.switchObject[props.type](props);
        }
        throw new Error(`Event of type ${props.type} doesn't exist`);
    }

    register(type, className) {
        this.switchObject[type] = props => new className(props);
    }

    registerSpecial(type, guiText, className) {
        const key = `${type}:${guiText}`;
        this.specialHandlers.set(key, props => new className(props));
    }
}

export default new ActionFactory();
